import { useCallback } from 'react';
import isAcceptanceTest from 'forms-utils-lib/localStorage/isAcceptanceTest';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { getFormTypeRoute } from 'FormsUI/lib/RouteGenerators';
import { useHistory } from 'react-router-dom';
export const useFormCreation = ({
  isPortalZeroState
}) => {
  const history = useHistory();
  const pushRoute = useCallback(route => history.push(route), [history]);
  const pushRedirect = useCallback((redirectPush, route) => redirectPush(route), []);
  const withTracking = fn => (isZeroState, ...args) => {
    if (!isAcceptanceTest()) {
      trackDashboardInteraction('create-new-form', {
        state: isZeroState ? 'zero-state' : 'has-forms'
      });
    }
    fn(...args);
  };
  const onCreateFormClick = useCallback(() => {
    const pushRedirectWithTracking = withTracking(pushRedirect);
    pushRedirectWithTracking(isPortalZeroState, pushRoute, getFormTypeRoute());
  }, [isPortalZeroState, pushRedirect, pushRoute]);
  return {
    onCreateFormClick
  };
};